module.exports = "/static/Images/es/Ten.png";